import CategoryPageContent from "../../../components/category-page/cateogry-page-content";
import GetStaticProps from "../../../utils/get-static-props";
export default function CategoryWomanizer({result}: {result:any}) {
  const content = `
    <p>
      <strong>
        Kondomer er et viktig verktøy for å beskytte seg mot seksuelt overførbare sykdommer og uønskede graviditeter. Men det kan være vanskelig å finne riktig størrelse for å oppnå optimal beskyttelse og komfort. Derfor er det viktig å kjenne til størrelsesguide og hvordan man måler for å finne riktig størrelse.
      </strong>
    </p>
    <p>
      Kondomer kommer i forskjellige størrelser og varianter, og det finnes ikke én størrelse som passer alle. Det er derfor viktig å finne riktig størrelse for å unngå at kondomet sprekker eller glir av under bruk. For å finne riktig størrelse, må man måle penisens omkrets. Dette kan gjøres ved å bruke et målebånd eller en tråd, og deretter måle lengden på tråden.
    </p>
    <p>
      Størrelsesguiden på kondomer er vanligvis oppgitt som omkrets, og kan variere fra produsent til produsent. Vanlige størrelser inkluderer small, medium, large og extra large. Det er viktig å velge riktig størrelse for å sikre optimal beskyttelse og komfort under bruk.
    </p>
    <p>
      Det er også verdt å merke seg at noen kondomer er tynnere enn andre, og derfor kan gi en mer følsom opplevelse. Disse kondomene kan imidlertid være mindre slitesterke og mindre beskyttende. Det er viktig å finne en balanse mellom følsomhet og beskyttelse for å oppnå optimal bruk av kondomer.
    </p>
    <p>
      I tillegg til størrelsen, er det også viktig å velge riktig type kondom. Noen kondomer er laget av latex, mens andre er laget av polyuretan eller polyisopren. For personer med latexallergi, kan det være lurt å velge kondomer laget av alternative materialer.
    </p>
  `;
  const category = 'Kondomer';
  return (
    <CategoryPageContent 
      result={result}
      category={category}
      content={content}
      categoryDescription="Et stort utvalg av kvalitetskondomer i forskjellige størrelser, fasonger og farger."></CategoryPageContent>
  );
}
export async function getStaticProps() {
    return GetStaticProps.category('Kondomer');
}